export default __webpack_public_path__ + "static/media/DiwaSmall.ad04dfa9.svg";